import { Model } from "@shared-features/models/model";
import { DynamicFieldTypes } from "@shared-features/enums/dynamic-field-types.enum";
import { Expose } from "class-transformer";


export class DynamicField extends Model {
    @Expose() id?: number = 0;
    @Expose() nameAr: string = '';
    @Expose() nameEn: string = '';
    @Expose() displayOrder: number = 0;
    @Expose() dataType: DynamicFieldTypes = DynamicFieldTypes.STRING;
    @Expose() isRequired = false;
    @Expose() isActive = true;
    @Expose() value?: string | number;
    @Expose() defaultValue?: string;
    @Expose() description?: string;
}